import React from 'react';

const ExtensaoFilterBar = ({ filters, onChange }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 mb-4 w-full max-w-full">
      <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 w-full">
        <input
          type="text"
          name="nome"
          placeholder="Nome da Extensão"
          value={filters.nome}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="cidade"
          placeholder="Cidade"
          value={filters.cidade}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="uf"
          placeholder="UF"
          value={filters.uf}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="status"
          placeholder="Status"
          value={filters.status}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="email"
          placeholder="Email"
          value={filters.email}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="nomeIgreja"
          placeholder="Igreja"
          value={filters.nomeIgreja}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="nomePastorPresidente"
          placeholder="Pastor Presidente"
          value={filters.nomePastorPresidente}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <input
          type="text"
          name="pais"
          placeholder="País"
          value={filters.pais}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <select
          name="estrangeira"
          value={filters.estrangeira}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        >
          <option value="">Estrangeira?</option>
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </select>
      </div>
    </div>
  );
};

export default ExtensaoFilterBar;
